import axios from 'axios';

// Global interceptor for direct axios calls
axios.interceptors.request.use(
  function (config) {
    // Add URL logging and request_url parameter
   // console.log("config", config?.url)
    
    // Add URL as a parameter to all requests
    if (config?.url) {
        // For GET requests, add URL as query parameter
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                request_url: `Webapp:${config.url}`
            };
        } 
        // For POST/PUT/PATCH requests, add URL to request body
        else if (['post', 'put', 'patch'].includes(config.method)) {
            if (config.data) {
                // If data is an object, add URL to it
                if (typeof config.data === 'object' && !Array.isArray(config.data)) {
                    config.data.request_url = `Webapp:${config.url}`;
                } else {
                    // If data is not an object, wrap it
                    config.data = {
                        ...config.data,
                        request_url: `Webapp:${config.url}`
                    };
                }
            } else {
                // If no data exists, create it
                config.data = {
                    request_url: `Webapp:${config.url}`
                };
            }
        }
    }
    
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
